import FileService from "@/services/file.service";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["showLoader"]),
  },
  methods: {
    async handleFileUpload(
      file,
      options = { visibility: 1 },
      startProgress = 0,
      maxContribution = 0.33
    ) {
      try {
        this.$store.commit("showLoader", true);

        const response = await FileService.uploadFile(
          file,
          options,
          startProgress,
          maxContribution
        );

        this.$store.commit("showLoader", false);
        return response;
      } catch (error) {
        console.error("Error uploading file:", error);
        this.$store.commit("showLoader", false);
        throw error;
      }
    },

    async handleFileDownload(fileId) {
      try {
        this.$store.commit("showLoader", true);
        const response = await FileService.getResultById(fileId);
        this.$store.commit("showLoader", false);
        return response;
      } catch (error) {
        console.error("Error downloading file:", error);
        this.$store.commit("showLoader", false);
        throw error;
      }
    },
    async getImage(fileId, key, moduleName) {
      try {
        // Fetch the binary data as a Blob
        const response = await FileService.getResultById(fileId);

        // Create a FileReader to convert the Blob to Base64
        const reader = new FileReader();

        reader.onloadend = () => {
          // Get the Base64 string
          const base64data = reader.result;

          // Set the Base64 string to moduleName
          this.$set(moduleName, key, base64data); // Use Vue's reactivity
        };

        // Read the Blob as a Data URL (Base64)
        reader.readAsDataURL(response.data);
      } catch (error) {
        console.error("Error fetching binary file:", error);
      }
    },
  },
};
